import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Spinner } from 'ui-component-library/components';

import {
  TextContainer,
  Container,
  ButtonsContainer,
  CancelButton,
  ConfirmButton,
  LoadingContainer,
} from './confirmation-modal.style';

/**
 * Confirmation modal component
 * @param {object} props - Object containing the props for this component
 * @param {string} props.title - Title to show in modal header
 * @param {string} props.text - Text to show in modal body
 * @param {element} props.children - Child components to show in modal body
 * @param {boolean} props.isOpen - Flag to show or hide modal
 * @param {boolean} props.isLoading - Flag to show or hide the spinner
 * @param {func} props.onClose - Function to call when the modal is closed
 * @param {func} props.onConfirm - Function to call when the user confirms
 * @param {func} props.onCancel - Function to call when the user cancels
 * @return {element}
 */
const ConfirmationModal = ({
  title,
  text,
  children,
  isOpen,
  isLoading,
  onClose,
  onConfirm,
  onCancel,
}) => (
  <div data-testid="Confirmation Modal">
    <Modal
      title={title}
      isOpen={isOpen}
      onModalClose={onClose}
      width="320px"
    >
      {!isLoading && (
        <Container>
          {text && <TextContainer>{text}</TextContainer>}
          {children}
          <ButtonsContainer>
            <CancelButton
              isSecondary
              text="CANCEL"
              onClick={onCancel}
            />
            <ConfirmButton
              text="CONFIRM"
              onClick={onConfirm}
            />
          </ButtonsContainer>
        </Container>
      )}
      {isLoading && (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      )}
    </Modal>
  </div>
);

ConfirmationModal.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ConfirmationModal.defaultProps = {
  text: '',
  children: null,
  isLoading: false,
};

export default ConfirmationModal;
